export enum APPLICATION {
  ODIN,
  FREYA
}
